import React, { ReactElement } from 'react';
import { useLocation } from 'react-router';
import Layout from '../Layout';
import routes from '../../routing/routes';
import AddSubjektBezPripomienokAdmin from '../../module/AddSubjektBezPripomienokAdmin';
import UserRole from '../../model/currentuser/UserRole';
import SecuredPage from '../../module/SecuredPage';

export default (): ReactElement => {
  // @ts-ignore
  const { pathname } = useLocation();

  return (
    <Layout
      breadcrumbRouteList={[{
        heading: routes.admin.addSubjektBezPripomienok.name,
        to: pathname,
      }]}
    >
      <SecuredPage
        allowForRoles={[UserRole.SUPERADMIN]}
      >
        <AddSubjektBezPripomienokAdmin />
      </SecuredPage>
    </Layout>
  );
};
